import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Acquista il Voucher",
    text: "Scegli tra Voucher Base, Premium e VIP. Al termine del pagamento ricevi subito il tuo codice personale.",
  },
  {
    n: "02",
    title: "Invia foto su WhatsApp",
    text: "Mostrami il parassita o la zona infestata col tuo Voucher. Analizzo il caso prima ancora di sentirci.",
  },
  {
    n: "03",
    title: "Ricevi la chiamata del Dottore",
    text: "Ti chiamo e ti guido passo-passo su cosa comprare, dove, e come applicarlo spendendo il minimo. Fino a 10 minuti con la Base, fino a 20 con la Premium.",
  },
];

export const HowItWorks = () => (
  <section id="come-funziona" className="bg-mossdeep py-24">
    <div className="max-w-6xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="max-w-2xl"
      >
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold font-bold mb-4">
          Come funziona
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug text-alabaster">
          Da infestato a disinfestato,{" "}
          <span className="italic text-gold">in tre mosse e una telefonata.</span>
        </h2>
      </motion.div>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.15 }}
            className="rounded-3xl border border-mosslight/40 bg-moss p-8 transition-all duration-300 hover:border-gold/60 hover:-translate-y-1"
          >
            <span className="font-serif text-5xl font-semibold text-gold/80">{s.n}</span>
            <h3 className="mt-5 text-xl font-semibold text-alabaster">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-alabaster/70">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
